/**
 * Placeholder shown while a structured fence block is still streaming in (or
 * when a non-streaming block has an empty body). Keeps raw JSON from leaking
 * into the chat before the artifact is complete.
 */
export function KaiBlockLoading({ label }: { label: string }) {
  return (
    <div className="glass-panel my-2 rounded-xl px-3 py-2 text-xs text-muted-foreground">
      {label}
    </div>
  );
}
